import React, { useMemo } from 'react'
import { Table, Space } from 'antd'
import { useFetch } from 'use-http'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHistory } from '@fortawesome/free-solid-svg-icons'

import GenericCard from '../../generic-card'
import MetricNumber from '../../metric-number'

import { createAdminGetUrl } from 'utils'
import { colors } from 'styles/variables'

const { Column } = Table

const AlunosAtivosPorPeriodicidade = () => {
  const { data, loading, error } = useFetch(
    createAdminGetUrl('DashMKTVendasAtivosPeriodicidade'),
    null,
    []
  )

  return (
    <GenericCard
      error={error}
      loading={loading}
      rightComponent={<FontAwesomeIcon icon={faHistory} color={colors.primaryColor} />}
      title="Alunos ativos por periodicidade"
    >
      <Table
        size="small"
        pagination={false}
        locale={{ filterConfirm: 'Aplicar', filterReset: 'Limpar', emptyText: 'Sem dados' }}
        dataSource={data}
      >
        <Column title="Periodicidade" dataIndex="periodicidade" key="periodicidade" />

        <Column
          title="Usuários Ativos"
          dataIndex="usuarios_ativos"
          align="center"
          key="usuarios_ativos"
          render={value => (
            <MetricNumber value={Number(value)}>{({ value }) => value}</MetricNumber>
          )}
        />

        <Column
          title="Percentual"
          dataIndex="percentual"
          align="center"
          key="percentual"
          render={value => (
            <MetricNumber value={Number(value)} suffix=" %">
              {({ formatedNumber }) => formatedNumber}
            </MetricNumber>
          )}
        />
      </Table>
    </GenericCard>
  )
}

export { AlunosAtivosPorPeriodicidade }
